import { render } from "./Equipe.vue?vue&type=template&id=20c3247d"
import script from "./Equipe.vue?vue&type=script&lang=ts"
export * from "./Equipe.vue?vue&type=script&lang=ts"
script.render = render

export default script